export const API_URL = process.env.REACT_APP_API_URL || process.env.REACT_APP_LOCAL;

// https://bw-spectral-cs-be.herokuapp.com/

// http://localhost:5000/